import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=26d4b40e&scoped=true"
import script from "./assign.vue?vue&type=script&lang=js"
export * from "./assign.vue?vue&type=script&lang=js"
import style0 from "./assign.vue?vue&type=style&index=0&id=26d4b40e&prod&lang=scss&scoped=true"
import style1 from "./assign.vue?vue&type=style&index=1&id=26d4b40e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d4b40e",
  null
  
)

export default component.exports